export const SUPPORTED_LOCALES = ['en', 'es', 'fr'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = 'en';

export function isSupportedLocale(x: unknown): x is SupportedLocale {
  return SUPPORTED_LOCALES.includes(x as SupportedLocale);
}

export function localeFromPathname(pathname: string): SupportedLocale {
  const segment = pathname.split('/')[1];
  return isSupportedLocale(segment) && segment !== DEFAULT_LOCALE
    ? segment
    : DEFAULT_LOCALE;
}

export function stripLocalePrefix(pathname: string): string {
  const segment = pathname.split('/')[1];
  if (isSupportedLocale(segment)) {
    const rest = pathname.slice(1 + segment.length) || '/';
    return rest.startsWith('/') ? rest : '/' + rest;
  }
  return pathname;
}

export function withLocale(locale: SupportedLocale, path: string): string {
  const clean = stripLocalePrefix(path);
  if (locale === DEFAULT_LOCALE) return clean;
  if (clean === '/') return `/${locale}`;
  return `/${locale}${clean.startsWith('/') ? clean : '/' + clean}`;
}
